import { Box, Tabs, Tab as MTab, Typography } from "@mui/material";
import Spinner from "components/spinner/Spinner";
import React, { Suspense, lazy, useState } from "react";
import { useParams } from "react-router-dom";
import TabsList from "./TabsList";

export default function Tab({ tab1, tab2 }) {
  const { shopCategory } = useParams();

  const DecorItemsPage = lazy(() =>
    import("components/collectionsCategories/CollectionsCategories")
  );
  const DecorConceptPage = lazy(() =>
    import("components/collectionsCategories/CollectionsCategories")
  );

  const PANELS = [
    {
      component: tab1?.map((item, idx) => (
        <DecorItemsPage key={idx} items={item} category={shopCategory} />
      )),
    },
    {
      component: tab2?.map((item, idx) => (
        <DecorConceptPage key={idx} items={item} category={shopCategory} />
      )),
    },
  ];

  const tabs = [
    {
      label: "decor items",
    },
    {
      label: "decor concepts",
    },
  ];

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <div className="grid 2xs:w-11/12 xs:w-11/12 xl:px-10 md:px-10 sm:w-11/12 md:w-full lg:w-full xl:w-full 2xl:w-full grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-x-5 mx-auto">
            {children}
          </div>
        )}
      </div>
    );
  }

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div>
        <TabsList value={value} handleChange={handleChange} tabs={tabs} />
      </div>
      <Suspense fallback={<Spinner />}>
        <>
          {PANELS.map((panel, idx) => (
            <TabPanel key={idx} value={value} index={idx}>
              {panel.component}
            </TabPanel>
          ))}
        </>
      </Suspense>
    </>
  );
}
